// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a074a449","885":"ba3cfd4f"}[chunkId] + ".chunk.js";
};